import { useWindowTitleContext } from '@ui/WindowTitle/context'
import type React from 'react'
import { useEffect } from 'react'

interface WindowTitleProps {
  title: string
}

export const WindowTitle: React.FC<WindowTitleProps> = ({ title }) => {
  const { setTitle, removeTitle } = useWindowTitleContext() ?? {}

  useEffect(() => {
    if (setTitle && removeTitle) {
      const key = setTitle(title)
      return () => {
        removeTitle(key)
      }
    }

    return undefined
  }, [setTitle, removeTitle, title])

  return null
}
